import { Component } from '@angular/core';

@Component({
  selector: 'app-cards4-examples-22',
  templateUrl: './cards4-examples-22.component.html'
})
export class Cards4Examples22Component {}
